/* ============================================================
 * Contact Us Help Section
 * ============================================================ */

(function () {
    'use strict';

    function initSection(section) {
        if (
            !section ||
            section.dataset.contactHelpInitialized === 'true'
        ) {
            return;
        }

        section.dataset.contactHelpInitialized = 'true';

        const groups = Array.from(
            section.querySelectorAll('[data-contact-help-group]')
        );

        let cursor = section.querySelector(
            '[data-contact-help-cursor]'
        );

        const supportsHover = window.matchMedia(
            '(hover: hover) and (pointer: fine)'
        ).matches;

        function hidePreviews() {
            groups.forEach((group) => {
                const preview = group.querySelector(
                    '.contact-us-help-section__preview'
                );

                group.classList.remove('is-previewing');

                if (preview) {
                    preview.style.opacity = '0';
                    preview.style.visibility = 'hidden';
                }
            });
        }

        hidePreviews();

        function setGroupHeight(group, open) {
            const panel = group.querySelector(
                '[data-contact-help-group-panel]'
            );

            if (!panel) {
                return;
            }

            panel.style.height = open
                ? `${panel.scrollHeight}px`
                : '0px';
        }

        function closeGroup(group) {
            group.classList.remove('is-active');

            group
                .querySelector('[data-contact-help-group-trigger]')
                ?.setAttribute('aria-expanded', 'false');

            setGroupHeight(group, false);
        }

        function openGroup(group) {
            groups.forEach((otherGroup) => {
                if (otherGroup !== group) {
                    closeGroup(otherGroup);
                }
            });

            group.classList.add('is-active');

            group
                .querySelector('[data-contact-help-group-trigger]')
                ?.setAttribute('aria-expanded', 'true');

            setGroupHeight(group, true);
        }

        groups.forEach((group) => {
            const trigger = group.querySelector(
                '[data-contact-help-group-trigger]'
            );

            const preview = group.querySelector(
                '.contact-us-help-section__preview'
            );

            trigger?.addEventListener('click', () => {
                if (group.classList.contains('is-active')) {
                    closeGroup(group);
                } else {
                    openGroup(group);
                }
            });

            if (supportsHover && preview) {
                trigger.addEventListener('pointerenter', () => {
                    hidePreviews();

                    if (preview) {
                        preview.style.opacity = '0';
                        preview.style.visibility = 'hidden';

                        requestAnimationFrame(() => {
                            preview.style.removeProperty('opacity');
                            preview.style.removeProperty('visibility');
                            group.classList.add('is-previewing');
                        });
                    }
                });

                trigger.addEventListener('pointermove', (event) => {
                    const previewWidth = 300;
                    const previewHeight = 169;
                    const offsetX = 90;

                    const maximumX = window.innerWidth - previewWidth - 20;
                    const maximumY = window.innerHeight - previewHeight - 20;

                    const nextX = Math.min(
                        maximumX,
                        event.clientX + offsetX
                    );

                    const nextY = Math.min(
                        maximumY,
                        event.clientY - previewHeight / 2
                    );

                    preview.style.setProperty(
                        '--contact-help-image-x',
                        `${Math.max(20, nextX)}px`
                    );

                    preview.style.setProperty(
                        '--contact-help-image-y',
                        `${Math.max(20, nextY)}px`
                    );
                });

                trigger.addEventListener('pointerleave', () => {
                    hidePreviews();
                });
            }
        });

        if (cursor && supportsHover) {
            let cursorX = 0;
            let cursorY = 0;
            let animationFrame = null;

            function updateCursor() {
                animationFrame = null;

                cursor.style.transform = `translate3d(
                    ${cursorX - 21}px,
                    ${cursorY - 21}px,
                    0
                )`;
            }

            function hideCursor() {
                cursor.classList.remove('is-visible');
            }

            section.addEventListener('pointermove', (event) => {
                const interactiveElement = event.target.closest(
                    [
                        '[data-contact-help-group-trigger]',
                        '[data-contact-help-trigger]'
                    ].join(', ')
                );

                if (
                    !interactiveElement ||
                    !section.contains(interactiveElement)
                ) {
                    hideCursor();
                    return;
                }

                cursor.classList.add('is-visible');

                cursorX = event.clientX;
                cursorY = event.clientY;

                if (!animationFrame) {
                    animationFrame = requestAnimationFrame(
                        updateCursor
                    );
                }
            });

            section.addEventListener('pointerleave', () => {
                hideCursor();
                hidePreviews();
            });
        }

        window.addEventListener('blur', () => {
            hidePreviews();

            if (cursor) {
                cursor.classList.remove('is-visible');
            }
        });

        window.addEventListener('pageshow', () => {
            hidePreviews();

            if (cursor) {
                cursor.classList.remove('is-visible');
            }
        });

        document.addEventListener('visibilitychange', () => {
            hidePreviews();

            if (cursor) {
                cursor.classList.remove('is-visible');
            }
        });

        window.addEventListener('resize', () => {
            groups.forEach((group) => {
                if (group.classList.contains('is-active')) {
                    setGroupHeight(group, true);
                }
            });
        });
    }

    function initAll(container = document) {
        container
            .querySelectorAll('.contact-us-help-section')
            .forEach(initSection);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initAll();
        });
    } else {
        initAll();
    }

    document.addEventListener(
        'shopify:section:load',
        (event) => {
            initAll(event.target);
        }
    );
})();
